import {Component, OnDestroy, OnInit} from '@angular/core';
import {Page} from '../model/page';
import {HelperProvider} from '../providers/helper.provider';
import {RestService} from '../providers/rest.service';
import {Siparis} from '../model/siparis';
import {IrsaliyelerPage} from '../model/irsaliyeler-page';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-irsaliyeler',
  templateUrl: './irsaliyeler.component.html',
  styleUrls: ['./irsaliyeler.component.css']
})
export class IrsaliyelerComponent implements OnInit, OnDestroy {
  irsaliyeAraLoading: any;
  irsaliyeAraText = "";
  showSearchResultCountIrsaliye = 10;
  showSearchResultCountModelIrsaliye: number[] = [10, 20, 50, 100];
  source: IrsaliyelerPage = null;
  showSearchCurrentPageSiparis = 1;
  durumText = 'Sipariş Onaylandı';
  siparisAraLoading = false;
  siparisAraText = '';
  showSearchResultCountSiparis = 10;
  showSearchResultCountModelSiparis: number[] = [10, 20, 50, 100];
  showSearchCurrentPageIrsaliye = 1;
  sourceSiparis: any = null;
  private subscriptions: Subscription[] = [];

  constructor(private helperProvider: HelperProvider,
              private restService: RestService) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Irsaliyeler);
    this.getSiparislerIrsaliyePage();
    this.getIrsaliyeler();
    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        this.getSiparislerIrsaliyePage();
        this.getIrsaliyeler();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  irsaliyeAraInputChange() {
    this.showSearchCurrentPageIrsaliye = 1;
    this.getIrsaliyeler();
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPageIrsaliye--;
    this.getIrsaliyeler();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPageIrsaliye++;
    this.getIrsaliyeler();
  }

  siparisAraInputChange() {
    this.showSearchCurrentPageSiparis = 1;
    this.getSiparislerIrsaliyePage();
  }

  showPreviousPageSearchResultsSiparis() {
    this.showSearchCurrentPageSiparis--;
    this.getSiparislerIrsaliyePage();
  }

  showNextPageSearchResultsSiparis() {
    this.showSearchCurrentPageSiparis++;
    this.getSiparislerIrsaliyePage();

  }

  // private getSiparisler() {
  //   this.restService.siparisler(this.showSearchCurrentPageSiparis, this.showSearchResultCountSiparis, [Siparis.DURUM_ONAYLANDI], this.siparisAraText)
  //     .subscribe(res => {
  //       this.sourceSiparis = res;
  //     });
  // }

  private getSiparislerIrsaliyePage() {
    this.restService.siparislerIrsaliyePage(this.showSearchCurrentPageSiparis, this.showSearchResultCountSiparis, [Siparis.DURUM_ONAYLANDI], this.siparisAraText)
      .subscribe(res => {
        this.sourceSiparis = res;
      });
  }

  getIrsaliyeler() {
    this.restService.irsaliyeler(this.showSearchCurrentPageIrsaliye, this.showSearchResultCountIrsaliye, null, this.irsaliyeAraText).subscribe(res => {
      this.source = res;
      // console.log(res)
    });
  }

}
